import {
  Box,
  Container,
  Flex,
  Heading,
  HStack,
  Link,
  ListItem,
  Text,
  UnorderedList,
  VStack,
} from "@chakra-ui/react";
import { INVOLVEMENT, focusTags } from "../assets/CV";
import LogoMark from "./LogoMark";
import SectionHeader from "./SectionHeader";
import TagRow from "./TagRow";

// Clubs, competitions and research keep the detailed timeline treatment.
export default function Involvement() {
  return (
    <Box id="involvement" py={{ base: 20, md: 28 }}>
      <Container maxW="5xl" px={{ base: 6, md: 8 }}>
        <SectionHeader
          eyebrow="03 / Clubs & Research"
          title="Involvement"
          description="Student teams, NASA programs and research where I led engineering work."
        />

        <VStack align="stretch" spacing={0}>
          {INVOLVEMENT.map((exp, index) => (
            <Flex
              key={`${exp.company}-${exp.startDate}`}
              role="group"
              align="flex-start"
              gap={{ base: 5, md: 10 }}
            >
              {/* Timeline rail */}
              <Flex direction="column" align="center" minW="10px" pt={2.5}>
                <Box
                  w="9px"
                  h="9px"
                  borderRadius="full"
                  border="1px solid"
                  borderColor="whiteAlpha.700"
                  bg="black"
                  flexShrink={0}
                  transitionProperty="background-color"
                  transitionDuration="0.25s"
                  _groupHover={{ bg: "white" }}
                />
                {index !== INVOLVEMENT.length - 1 && (
                  <Box w="1px" flex={1} bg="whiteAlpha.200" minH="60px" />
                )}
              </Flex>

              {/* Content */}
              <Box pb={{ base: 12, md: 16 }} flex={1}>
                <Text
                  fontFamily="mono"
                  fontSize="xs"
                  letterSpacing="0.08em"
                  color="whiteAlpha.500"
                  mb={4}
                >
                  {exp.startDate} — {exp.endDate}
                </Text>

                <LogoMark
                  logo={exp.logo}
                  tone={exp.logoTone}
                  monogram={exp.monogram}
                  alt={exp.company}
                  height="30px"
                  maxWidth="120px"
                />

                <Heading
                  fontSize={{ base: "lg", md: "xl" }}
                  fontWeight="500"
                  letterSpacing="-0.02em"
                  color="white"
                  mt={4}
                >
                  {exp.company}
                </Heading>

                <Text color="whiteAlpha.600" fontSize="sm" mt={1}>
                  {exp.role}
                </Text>

                <UnorderedList
                  color="whiteAlpha.700"
                  fontSize="sm"
                  lineHeight="1.8"
                  maxW="3xl"
                  mt={5}
                  spacing={2}
                  pl={4}
                >
                  {exp.description.map((bullet, i) => (
                    <ListItem key={i}>{bullet}</ListItem>
                  ))}
                </UnorderedList>

                <VStack align="flex-start" spacing={5} mt={5}>
                  <TagRow
                    label="Focus"
                    items={focusTags(exp)}
                  />
                  <TagRow
                    label="Technical Skills"
                    variant="solid"
                    items={exp.skills ?? []}
                  />
                </VStack>

                {exp.links.length > 0 && (
                  <HStack spacing={6} flexWrap="wrap" mt={5}>
                    {exp.links.map((link) => (
                      <Link
                        key={link.url}
                        href={link.url}
                        isExternal
                        color="whiteAlpha.600"
                        fontSize="sm"
                        borderBottom="1px solid"
                        borderColor="whiteAlpha.300"
                        _hover={{
                          color: "white",
                          borderColor: "white",
                          textDecoration: "none",
                        }}
                      >
                        {link.descr}
                      </Link>
                    ))}
                  </HStack>
                )}
              </Box>
            </Flex>
          ))}
        </VStack>
      </Container>
    </Box>
  );
}
